import React, { useState, useEffect } from "react";
import { Switch, Route, useHistory, Router, Link, useParams } from "react-router-dom"
import ProdCard from './ProdCard'
import ProdListContent from "./ProdListContent";
import ProdReviewContent from "./ProdReviewContent";
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import axios from 'axios';
import translate from '../../other/translate.json';
import PageNotFound from "../Errors/PageNotFound";
import config from '../../other/config';
const { serverAPI } = config;

export default function ProdListRouter(props) {
	const language = localStorage.getItem('language') || 'Ru'
	let { handleExpandClick, selectedIndex, prodBasketChips, appsAppsNeeded, appsAppsRecom } = props
	const basketChips = ''
	let { bank } = useParams();
	let history = useHistory()

	// const setAppBasket = (app) => {
	// 	if (appBasket.some((element) => element === app.ID) === true) {
	// 		_appBasket(appBasket.filter(el_ => el_ !== app.ID))
	// 	} else {
	// 		_appBasket(appBasket.concat([app.ID]))
	// 	}
	// }

	const classes = useStyles();
	const [bankinfo, setBankinfo] = useState({});
	const [statusBtn, setStatusBtn] = useState(0);




	// useEffect(() => {
	// 	setBasketChips(union(appBasket))
	// 	localStorage.setItem('cartApp', JSON.stringify(union(appBasket)))
	// }, [appBasket])

	// useEffect(() => {
	// 	// setProdBasketChips(prodBasket)
	// 	localStorage.setItem('cartProd', JSON.stringify(prodBasket))
	// }, [prodBasket])

	// const setAppProd = (prod) => {
	// 	if (prodBasket.some((element) => element === prod.ID) === true) {
	// 		_prodBasket(prodBasket.filter(el_ => el_ !== prod.ID))
	// 		let arr_ = []
	// 		appBasket.forEach(el => {
	// 			if (prod['AppsIDsNeeded'] !== null && prod['AppsIDsRecommended'] !== null && (prod['AppsIDsNeeded'].length  + prod['AppsIDsRecommended'].length > 0)) {
	// 				if (prod['AppsIDsNeeded'].concat(prod['AppsIDsRecommended']).includes(el)) {

	// 				} else {
	// 					arr_.push(el)
	// 				}
	// 			}
	// 		})
	// 		_appBasket(arr_)

	// 	} else {
	// 		_prodBasket(prodBasket.concat([prod.ID]))
	// 		if (prod['AppsIDsNeeded'] === null && prod['AppsIDsRecommended'] === null) {
	// 		}
	// 		else if (prod['AppsIDsNeeded'].length + prod['AppsIDsRecommended'].length > 0) {
	// 			let need__ = prod['AppsIDsNeeded'].length > 0 ? prod['AppsIDsNeeded'].split(',') : []
	// 			let recom__ = prod['AppsIDsRecommended'].length > 0 ? prod['AppsIDsRecommended'].split(',') : []
	// 			_appBasket(appBasket.concat(need__.concat(recom__)))
	// 		}
	// 		else {
	// 		}
	// 	}
	//  }

	const StyledButton = withStyles({
		root: {
			background: 'transparent',
			borderRadius: 0,
			border: 0,
			borderBottom: '1px solid #93919B',
			height: 48,
			padding: '0 30px',
			color: '#8987A2',
			fontFamily: 'Cera CY',
			fontStyle: 'normal',
			fontWeight: 'normal',
			fontSize: '16px',
			lineHeight: '24px',
		},

		label: {
			textTransform: 'capitalize',
		},
	})(Button);

	const StyledButtonSelected = withStyles({
		root: {
			background: 'transparent',
			borderRadius: 0,
			border: 0,
			borderBottom: '3px solid #24262A',
			height: 48,
			padding: '0 30px',
			color: '#24262A',
			fontFamily: 'Cera CY',
			fontStyle: 'normal',
			fontWeight: 'normal',
			fontSize: '16px',
			lineHeight: '24px',
		},

		label: {
			textTransform: 'capitalize',
		},
	})(Button);

	useEffect(() => {
		if (/overview/gmi.test(history.location.pathname)) { setStatusBtn(0) }
		if (/prodlist/gmi.test(history.location.pathname)) { setStatusBtn(1) }
		if (/card/gmi.test(history.location.pathname)) { setStatusBtn(3) }
	}, [history.location.pathname])

	useEffect(() => {
		//handleExpandClick(2)   Tarasenko логика перенесена на LeftBar

		let didCancel = false;
		async function fetchData() {
			// const _bankinfo = await axios.get(`${serverAPI}/bankinfo/${bank}/${props.selectedIndex}/${language}`)
			const _bankinfo = await axios.get(`${serverAPI}/bankinfo/${window.location.pathname.split('/')[2]}/${props.selectedIndex}/${language}`)			
			if (!didCancel) {
				if (_bankinfo && _bankinfo.data) {
					setBankinfo(_bankinfo.data[0])
				}
			}
		}

		fetchData();
		return () => {
			didCancel = true;
		}
	}, [bank]);

	function swRoute(path) {
		switch (path.substr(-8)) {
			case 'overview': { break; }
			case 'prodlist': { break; }
			default: props.setErr(true);
		}
	}

	return (
		<Grid container>
			<Grid
				item
				container
				lg={12} md={12} sm={12}
				direction="row"
				justify="space-between"
				alignItems="center"
				style={{ minHeight: 58 }}
			>
				<Grid item>
					<Typography className={classes.sectionTitle} variant="h5">{(bankinfo && bankinfo[`Title`]) || ''}</Typography>
				</Grid>

				<Grid item></Grid>
				{statusBtn === 3 ? '' :
					<Grid item>
						<ButtonGroup size="small" aria-label="small outlined button group">
							{
								statusBtn === 0
									?
									<Link to={`/products/${bank}/overview`} onClick={() => setStatusBtn(0)} style={{ textDecoration: 'none' }}>
										<StyledButtonSelected>{translate.Words[`Overview${language}`]}</StyledButtonSelected>
									</Link>
									:
									<Link to={`/products/${bank}/overview`} onClick={() => setStatusBtn(0)} style={{ textDecoration: 'none' }}>
										<StyledButton>{translate.Words[`Overview${language}`]}</StyledButton>
									</Link>
							}

							{
								statusBtn === 1
									?
									<Link to={`/products/${bank}/prodlist`} onClick={() => setStatusBtn(1)} style={{ textDecoration: 'none' }}>
										<StyledButtonSelected>{translate.Words[`Products_${language}`]}</StyledButtonSelected>
									</Link>
									:
									<Link to={`/products/${bank}/prodlist`} onClick={() => setStatusBtn(1)} style={{ textDecoration: 'none' }}>
										<StyledButton>{translate.Words[`Products_${language}`]}</StyledButton>
									</Link>
							}
						</ButtonGroup>
					</Grid>}
			</Grid>


			<Switch>
				<Router history={history}>
					<Route exact path='/products/:bank/overview'>
						<ProdReviewContent
							selectedIndex={selectedIndex}
							bankinfo = {bankinfo}
						/>
					</Route>

					<Route exact path='/products/:bank/prodlist'>
						<ProdListContent
							// setListNumProps={props.setListNumProps}
							prodBasketChips={props.prodBasketChips}
							info={bankinfo}
							userCollection = {props.userCollection}
							saveCollection = {props.saveCollection}
						/>
					</Route>

					<Route path='/products/card/:code'>
						<ProdCard
							isAuth={props.isAuth}
							usname={props.usname}
							appNeed={appsAppsNeeded}
							appRecom={appsAppsRecom}
							// appBasket={appBasket}
							// prodBasket={prodBasket}

							// setAppBasket={setAppBasket}

							// basketChips={basketChips}
							// setAppProd={setAppProd}
							// prodBasketChips={prodBasketChips}
							info={bankinfo}
							setErr={props.setErr}
							kloUser = {props.kloUser}
							getKloStatuses = {props.getKloStatuses}
							userCollection = {props.userCollection}
							saveCollection = {props.saveCollection}
						/>
					</Route>

					{/* <Route>
						<PageNotFound IsRu={language === 'Ru'} />
					</Route> */}

					{
						window.location.pathname.substr(0, 15) !== '/products/card/' && bankinfo == undefined
							?
							props.setErr(true)
							:
							// console.log(window.location.pathname)
							window.location.pathname.substr(0, 15) !== '/products/card/'
								?
								window.location.pathname.substr(-8) == 'prodlist' || window.location.pathname.substr(-8) == 'overview'
									?
									null
									:
									swRoute(window.location.pathname)
								:
								null
					}
				</Router>
			</Switch>
		</Grid>
	)
}

const useStyles = makeStyles(theme => ({
	sectionTitle: {
		fontSize: 40,
		fontWeight: 500,
	},
}));